<template>
  <TOverlay :show="isFormLoading">
    <TForm
      novalidate
      class="space-y-4"
      @submit.prevent="onSubmit"
    >
      <TFormGroup
        :label="t('user.firstName')"
        label-for="complete-profile-firstname"
        :field="r$.FirstName"
      >
        <TInput
          id="complete-profile-firstname"
          v-model="form.FirstName"
          :mask="SAFE_INPUT_TEXT_MASK_REGEXP"
          name="firstName"
         
          is-imask-input
          @accept="form.FirstName = $event"
        />
      </TFormGroup>

      <TFormGroup
        :label="t('user.lastName')"
        label-for="complete-profile-lastname"
        :field="r$.LastName"
      >
        <TInput
          id="complete-profile-lastname"
          v-model="form.LastName"
          :mask="SAFE_INPUT_TEXT_MASK_REGEXP"
          name="lastName"
         
          is-imask-input
          @accept="form.LastName = $event"
        />
      </TFormGroup>

      <TFormGroup
        :label="t('user.phoneNumber')"
        label-for="complete-profile-phone"
        :field="r$.PhoneNumber"
      >
        <TInputPhone
          id="complete-profile-phone"
          v-model="form.PhoneNumber"
          v-model:country-calling-code="form.CountryPhoneCode"
         
        />
      </TFormGroup>

      <TFormGroup
        :label="t('user.email')"
        label-for="complete-profile-email"
      >
        <TInput
          id="complete-profile-email"
          :model-value="userEmail"
          type="email"
          name="email"
          readonly
         
        />
      </TFormGroup>

      <TButton
        block
        type="submit"
       
      >
        {{ t('actions.continue') }}
      </TButton>

      <TButton
        v-if="authenticationIntent !== 'BookingIntent'"
        block
        variant="link"
        type="button"
       
        @click="finishProfile"
      >
        {{ t('auth.profile.skip') }}
      </TButton>
    </TForm>
  </TOverlay>
</template>

<script setup lang="ts">
import { required } from '@regle/rules'
import { SAFE_INPUT_TEXT_MASK_REGEXP } from '~/constants/validation'

const { t } = useI18n()
const { $captureError, $rentals } = useNuxtApp()
const { getSession } = useAuth()
const { finishProfile } = useAuthentication()
const { userFirstName, userLastName, userEmail } = useUser()
const authenticationIntent = useAuthenticationIntent()

const isFormLoading = ref(false)

const form = ref({
  FirstName: userFirstName.value,
  LastName: userLastName.value,
  PhoneNumber: '',
  CountryPhoneCode: '',
})

const { r$ } = useRegle(form, () => ({
  FirstName: { required },
  LastName: { required },
  CountryPhoneCode: { required },
  PhoneNumber: { required, phoneValid: phoneValid(() => form.value.CountryPhoneCode) },
}))

async function onSubmit() {
  if (isFormLoading.value) {
    return
  }

  const { valid } = await r$.$validate()

  if (!valid) {
    return
  }

  try {
    isFormLoading.value = true

    await $rentals('/api/user-profiles/me', {
      method: 'PUT',
      body: {
        FirstName: form.value.FirstName,
        LastName: form.value.LastName,
        PhoneNumber: form.value.PhoneNumber,
        CountryPhoneCode: form.value.CountryPhoneCode,
      },
    })

    await getSession()
    await finishProfile()
  }
  catch (error) {
    $captureError(error)
  }
  finally {
    isFormLoading.value = false
  }
}
</script>

<i18n src="~~/i18n/locales/common/auth/profile.json" lang="json" />
